<ion-toolbar mode="md">
 <ion-item mode="ios">
  <app-shop-avatar 
  slot="start"
  [shop]="shopWithStories.shop"
  [shopOutlets]="shopOutlets"
  ></app-shop-avatar>
  <ion-label (click)="viewAction()">
    <h1>{{shopWithStories.shop.name}}</h1>
    <!-- <p style="max-height: 2.5em;
    overflow: hidden;
    text-overflow: ellipsis;">{{shopWithStories.shop.address}}</p> -->
  </ion-label>
  <!-- TODO this should open a place preview with photos and such -->
  <!-- <ion-icon name="information-circle" color="light" slot="end"></ion-icon>  -->
  <!-- <ion-icon name="location" color="dark" slot="end"></ion-icon> -->
 </ion-item>
  <swiper 
  #swiper 
  [config]="swiperConfig"
  (swiper)="onSwiper($event)"
  (beforeTransitionStart)="onBeforeTransitionStart($event)">
    <ng-template swiperSlide *ngFor="let story of shopWithStories.stories;" >
     <app-story-lane-card 
     [story]="story"
     [shop]="shopWithStories.shop"
     [cardHeight]="cardHeight"
     (onWantsToFlip)="slideNext()"
     (onStorySelectEmit)="dealSelected($event)"
     >
     </app-story-lane-card>
    </ng-template>
</swiper>
</ion-toolbar>

